import { Component, OnInit, Input, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';

import { OlMainComponent } from 'gmap';
import { Site,Supervision } from 'solar-bo';

import { FrCoordinate } from 'gmap';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OlMapOptions } from 'gmap';

@Component({
  selector: 'app-superv-map',
  templateUrl: './superv-map.component.html',
  styleUrls:['./superv-map.component.scss']
})
export class SupervMapComponent implements OnInit, AfterViewInit, OnChanges {


  @Input() mapid: string;
  @Input() supervision: Supervision;
  @Input() location: FrCoordinate;
  @Input() mapHeight="100%";
  @Input() mapWidth="100%";
  @Input() options:OlMapOptions;
  @ViewChild('map') map: OlMainComponent;
  get loadingList(){
    return this.map.loadinglist;
  }
  set loadingList(value:boolean){
    this.map.loadinglist=value;
  }
  get alertmessage(){
    return this.map.alertmessage;
  }
  set alertmessage(value:any){
    this.map.alertmessage=value;
  }

  layersViewVisible:boolean=false;//show hide layers selector

  constructor(public dialog: MatDialog) { }

  ngOnInit() {    
    if (this.map) {
      //this.map.id=this.mapid;
    }
  }

  ngAfterViewInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log("SupervMapComponent ngOnChanges " ,changes);
    let typeChange = changes['supervision'];
    if (typeChange && (!typeChange.firstChange || typeChange.previousValue == undefined)) {
      //this.loadmap();
    }
    typeChange = changes['location'];
    if (typeChange && (!typeChange.firstChange || typeChange.previousValue == undefined)) {
      //this.location = typeChange.currentValue;
      
    }
    if (this.map){
      //this.map.id=this.mapid;
    }
  }

}
